<template>
  <div v-if="multiSectionList && multiSectionList.length"  class="multi-section-wrap">
    <div v-for="(sectionInfo) in multiSectionList" :key="sectionInfo.title" class="multi-section-container">
      <DynamicSectionLoader :section-info="sectionInfo" v-on-display="sectionInfo" />
    </div>
  </div>
</template>

<script>
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import { onDisplay } from '@/common/directives'
export default {
  name: 'BandRouterView',
  components: { DynamicSectionLoader },
  props: {
    multiSectionList: {
      type: Array
    }
  },
  directives: {
    onDisplay
  }
}
</script>
